<template>
	<div class="main-body p-0">
		<div class="inner-wrapper">
			<div class="inner-main">
				<page-header :propButtons="page.buttons" :propConfig="page.header" :propModel="dataModel" @action-create="mtd_showCreateResourceModal"></page-header>
				<div class="inner-main-body">
					<page-body
						:propHeader="dataTable.header"
						:propBody="dataTable.body"
						:propModel="dataModel"
						@action-next-pagination="mtd_nextPagination"
						@action-edit="mtd_showEditResourceModal"
						@action-remove="mtd_removeResource"
						@toggle-state="mtd_toggleStateResource"
						@action-sonwindow-close="mtd_sonWindowClose"
						@users="mtd_users">
						<template slot="content-filter">
							<component :is="filter_component" @emit-init-pagination="mtd_initPagination" :prop-execute="executeFilter" :page="dataTable.header.page"></component>
						</template>
						<template slot="content-sonwindow">
							<component :is="dataTable.body.sonWindow.component" :propRow="dataTable.body.sonWindow.row" @action-sonwindow-close="mtd_sonWindowClose" @success="mtd_pageSuccess" />
						</template>
					</page-body>
				</div>
			</div>
		</div>

		<modal v-for="modal in modals" :key="modal.id" class="bg-black-trans" :id="modal.id" :propConfig="modal.config" @action-close="mtd_closeModal(modal.id)">
			<template v-if="modal.id == 'main-form'">
				<component
					:is="modal.slot.component"
					slot="content-modal"
					:propInfo="modal.slot"
					:modal_id="modal.id"
					@onload="mtd_componentOnload(modal.id)"
					@success="mtd_componentSuccess"
					@error="mtd_componentError"
					@close="mtd_closeModal(modal.id)"></component>
			</template>
		</modal>
	</div>
</template>
<script>
import { mapActions, mapGetters } from 'vuex';
/** Components */
import MainForm from './components/MainForm';
import MainFilter from './components/MainFilter';
/** Page */
import UsersPage from './pages/UsersPage';
export default {
	components: {
		MainForm,
		MainFilter,
		UsersPage,
	},
	data() {
		return {
			filter_component: 'main-filter',
			executeFilter: 0,
			dataModel: {
				getter: 'job_positions_index',
				prefixPermission: 'jobpositions',
				alias: 'Puestos de trabajo',
				icon: 'fas fa-swatchbook',
			},
			page: {
				header: {
					menu: ['Puestos de trabajo'],
				},
				buttons: {
					create: true,
					import: false,
					export: false,
				},
			},
			dataTable: {
				header: {
					title: 'Puestos de trabajo',
					filter: false,
					page: 1,
					wordsearch: '',
				},
				body: {
					cols: [
						{
							name: 'name',
							alias: 'Nombre',
							width: '',
						},
						{
							name: 'type_name',
							alias: 'Tipo',
							width: '',
						},
						{
							name: 'enterprise_denomination',
							alias: 'Empresa',
							width: '',
						},
						{
							name: 'campu_name',
							alias: 'Sede',
							width: '',
						},
					],
					buttons: {
						edit: true,
						remove: true,
						width: '',
					},
					myButtons: [
						{
							text: 'U',
							class: 'btn-primary btn-xs',
							tooltip: 'Subcategorias',
							component: 'users',
							title: "<span class='fa fa-list'></span> Subcategorias con accesos para ",
							can: 'home-index',
							modalSize: 'modal-lg',
							scroll: true,
							play: {
								type: 'state',
								name: 'type',
								0: false,
								1: true,
							},
						},
					],
					sonWindow: {
						component: null,
						row: null,
					},
				},
			},
			modals: [
				{
					id: 'main-form',
					slot: {
						component: null,
						data: {
							row: null,
							buttonSubmit: null,
							method: null,
						},
					},
					config: {
						title: null,
						id: 'main-form',
						idHash: '#main-form',
						size: null,
						scroll: true,
						position: '',
					},
				},
			],
		};
	},
	computed: {
		...mapGetters(['url_api']),
	},
	methods: {
		...mapActions(['get', 'post', 'destroy', 'execute_commit', 'update']),
		///////////////////// METODO POR DEFECTO /////////////////////
		mtd_componentOnload: function (modal_id) {
			window.$(`#${modal_id}`).modal('show');
		},
		mtd_pageSuccess: function () {
			//
		},

		mtd_componentSuccess: function ({ component, res, action, modal_id }) {
			switch (component) {
				case 'main-form':
					if (action == 'store') {
						this.execute_commit({ mutation: 'JOB_POSITIONS_INDEX__ADD_RESOURCE', payload: { job_position: res.job_position } });
					}
					if (action == 'update') {
						this.execute_commit({ mutation: 'JOB_POSITIONS_INDEX__UPDATE_RESOURCE', payload: { job_position: res.job_position } });
					}
					this.mtd_closeModal(modal_id);
					break;
				default:
					window.message('Warning', `No existe el modal ${component}`);
					break;
			}
		},
		mtd_componentError: function () {},
		mtd_closeModal: function (modal_id) {
			window.$(`#${modal_id}`).modal('hide');
			this.modals.find(el => el.id == modal_id).slot = {
				component: null,
				data: {
					row: null,
					buttonSubmit: null,
					method: null,
				},
			};
		},
		mtd_sonWindowClose: function () {
			this.dataTable.body.sonWindow = {
				component: null,
				row: null,
			};
		},
		mtd_nextPagination: function (page) {
			this.dataTable.header.page = page;
		},
		mtd_initPagination: function () {
			this.dataTable.header.page = 0;
		},
		mtd_showCreateResourceModal: function () {
			const main_form = this.modals.find(el => el.id == 'main-form');

			main_form.slot.component = 'main-form';
			main_form.slot.data = {
				row: null,
				method: 'create',
				buttonSubmit: 'Registrar puesto de trabajo',
			};
			main_form.config.scroll = true;
			main_form.config.size = 'modal-md';
			main_form.config.position = 'modal-right';
			main_form.config.title = "<span class='fa fa-plus'></span> Nuevo puesto de trabajo";
		},
		mtd_showEditResourceModal: function (row) {
			const main_form = this.modals.find(el => el.id == 'main-form');

			main_form.slot.component = 'main-form';
			main_form.slot.data = {
				row: row,
				method: 'edit',
				buttonSubmit: 'Actualizar puesto de trabajo',
			};
			main_form.config.scroll = true;
			main_form.config.size = 'modal-md';
			main_form.config.position = 'modal-right';
			main_form.config.title = "<span class='fa fa-plus'></span> Editando puesto de trabajo";
		},
		mtd_toggleStateResource(row) {
			this.$swal
				.fire({
					title: `¿Esta seguro de ${row.enabled == 1 ? 'desactivar' : 'activar'} este puesto de trabajo?`,
					text: `${row.name}`,
					icon: 'warning',
					showCancelButton: true,
					confirmButtonColor: `${row.enabled == 1 ? '#e74c3c' : '#28a745'}`,
					confirmButtonText: `Si, ${row.enabled == 1 ? 'desactivar' : 'activar'}`,
				})
				.then(result => {
					if (result.isConfirmed) {
						this.update({ url: `${this.url_api}/jobposition/${row.id}/toggle-state` }).then(res => {
							if (res.state == 'success') {
								this.execute_commit({ mutation: 'JOB_POSITIONS_INDEX__UPDATE_RESOURCE', payload: { jobposition: res.jobposition } });
							}
						});
					}
				});
		},
		mtd_removeResource: function (row) {
			this.destroy({ url: `${this.url_api}/job_position/${row.id}/remove` }).then(res => {
				if (res.state == 'success') {
					this.execute_commit({ mutation: 'JOB_POSITIONS_INDEX__REMOVE_RESOURCE', payload: { job_position: row } });
					window.message('success', 'Eliminación exitosa');
				}
			});
		},
		mtd_users: function (role) {
			this.dataTable.body.sonWindow = {
				component: 'users-page',
				row: role,
			};
		},
	},
	beforeDestroy() {
		this.execute_commit({ mutation: 'JOB_POSITIONS_INDEX__CLEAR_ALL' });
	},
};
</script>
